var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 13,
    fill: "#D1D1D1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1549,
    transform: "translate(-508 -281)",
    fill: "#F5F6F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_955_15933)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -48,
    y: -119,
    width: 1000,
    height: 1310,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.396 -13.016H-20.976V-8.93H-15.63V-7.346H-20.976V-2H-22.65V-14.6H-15.396V-13.016ZM-6.07875 -11H-4.51275V-2H-6.07875V-3.548C-6.79875 -2.45 -7.95075 -1.766 -9.48075 -1.766C-11.9827 -1.766 -14.0347 -3.836 -14.0347 -6.5C-14.0347 -9.164 -11.9827 -11.234 -9.48075 -11.234C-7.95075 -11.234 -6.79875 -10.55 -6.07875 -9.452V-11ZM-9.28275 -3.278C-7.46475 -3.278 -6.07875 -4.664 -6.07875 -6.5C-6.07875 -8.336 -7.46475 -9.722 -9.28275 -9.722C-11.0827 -9.722 -12.4688 -8.336 -12.4688 -6.5C-12.4688 -4.664 -11.0827 -3.278 -9.28275 -3.278ZM2.08988 -1.766C-0.628125 -1.766 -2.64412 -3.836 -2.64412 -6.5C-2.64412 -9.164 -0.628125 -11.234 2.08988 -11.234C3.87188 -11.234 5.38388 -10.298 6.06788 -8.876L4.75388 -8.12C4.30388 -9.074 3.29588 -9.704 2.08988 -9.704C0.289875 -9.704 -1.07812 -8.318 -1.07812 -6.5C-1.07812 -4.7 0.289875 -3.314 2.08988 -3.314C3.31388 -3.314 4.30388 -3.944 4.80788 -4.88L6.13988 -4.106C5.38388 -2.702 3.85388 -1.766 2.08988 -1.766ZM13.9136 -11H15.4796V-2H13.9136V-3.296C13.2476 -2.234 12.2576 -1.766 10.9976 -1.766C8.89162 -1.766 7.50563 -3.17 7.50563 -5.474V-11H9.07163V-5.564C9.07163 -4.088 9.91763 -3.26 11.3036 -3.26C12.7436 -3.26 13.9136 -4.106 13.9136 -6.23V-11ZM17.8638 -2V-15.14H19.4298V-2H17.8638ZM26.7149 -9.488H24.3209V-4.61C24.3209 -3.242 25.1129 -3.332 26.7149 -3.404V-2C24.0149 -1.64 22.7549 -2.36 22.7549 -4.61V-9.488H20.9729V-11H22.7549V-13.052L24.3209 -13.52V-11H26.7149V-9.488ZM35.0442 -11H36.7182L33.0462 -1.442C32.2902 0.574 30.8862 1.726 29.0502 1.6V0.142C30.2562 0.232 31.0122 -0.506 31.4802 -1.694L31.6422 -2.036L27.7182 -11H29.3922L32.4522 -3.944L35.0442 -11Z",
    fill: "#7F7F7F",
    fillOpacity: 0.968627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 -18.5H342C343.933 -18.5 345.5 -16.933 345.5 -15V28C345.5 29.933 343.933 31.5 342 31.5H-20C-21.933 31.5 -23.5 29.933 -23.5 28V-15C-23.5 -16.933 -21.933 -18.5 -20 -18.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 -18.5H342C343.933 -18.5 345.5 -16.933 345.5 -15V28C345.5 29.933 343.933 31.5 342 31.5H-20C-21.933 31.5 -23.5 29.933 -23.5 28V-15C-23.5 -16.933 -21.933 -18.5 -20 -18.5Z",
    stroke: "#DDE2E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -7,
    width: 79,
    height: 27,
    rx: 4,
    fill: "#0089CE",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    y: -6.5,
    width: 78,
    height: 26,
    rx: 3.5,
    stroke: "#0089CE",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 12.7708C3.54079 12.7708 0.729126 9.95916 0.729126 6.49999C0.729126 3.04082 3.54079 0.229156 6.99996 0.229156C10.4591 0.229156 13.2708 3.04082 13.2708 6.49999C13.2708 9.95916 10.4591 12.7708 6.99996 12.7708ZM6.99996 1.10416C4.02496 1.10416 1.60413 3.52499 1.60413 6.49999C1.60413 9.47499 4.02496 11.8958 6.99996 11.8958C9.97496 11.8958 12.3958 9.47499 12.3958 6.49999C12.3958 3.52499 9.97496 1.10416 6.99996 1.10416Z",
    fill: "#0089CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34913 8.58832C5.23829 8.58832 5.12746 8.54749 5.03996 8.45999C4.87079 8.29082 4.87079 8.01082 5.03996 7.84166L8.34163 4.53999C8.51079 4.37082 8.79079 4.37082 8.95996 4.53999C9.12913 4.70916 9.12913 4.98916 8.95996 5.15832L5.65829 8.45999C5.57663 8.54749 5.45996 8.58832 5.34913 8.58832Z",
    fill: "#0089CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65079 8.58832C8.53996 8.58832 8.42913 8.54749 8.34163 8.45999L5.03996 5.15832C4.87079 4.98916 4.87079 4.70916 5.03996 4.53999C5.20913 4.37082 5.48913 4.37082 5.65829 4.53999L8.95996 7.84166C9.12913 8.01082 9.12913 8.29082 8.95996 8.45999C8.87246 8.54749 8.76163 8.58832 8.65079 8.58832Z",
    fill: "#0089CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_955_15933",
    x: -65,
    y: -132,
    width: 1034,
    height: 1344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_955_15933"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_955_15933",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconBlue);
export default __webpack_public_path__ + "static/media/close-icon-blue.5def4972cb3ac568a3e0e9c6751a9a09.svg";
export { ForwardRef as ReactComponent };